module.exports = __webpack_public_path__ + "img/pole-status-yellow.c1da7fc0.webp";